import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'
import {alertActions, contracterActions} from "../../../../store/actions";
import moment from "moment";
import history from "../../../../route/history";
import {commons} from "../../../../hook/common";
import ServiceDashboard from '../../../../layout/service/ServiceDashBoard' // 2021.06 DashBoard 추가

const CertificateApplyDetail = props => {
    const queryString = require('query-string');
    let [state, setState] = useState();
    const [ historyInfo, setHistoryInfo] = useState({});

    const fileType = [
    { title: '수출신고필증', value: '811' },
    { title: 'Documentary credit(수출신용장)', value: '465' },
    { title: '외화표시 물품공급계약서', value: '2AN' },
    ]

    /**
     * 문서정보 조회
     */
    useEffect(() => {
        const locationInfo = props.location?.state;

        if (!props.match.params.seq) {
            history.replace('/service/inbox');
            return;
        }

        props.load(props.match.params.seq);

        setHistoryInfo({
            ...historyInfo,
            selectedSubject: locationInfo?.selectedSubject,
            tabStatus: locationInfo?.tabStatus,
            srhFrom: locationInfo?.srhFrom,
            srhTo: locationInfo?.srhTo,
            srhKind: locationInfo?.srhKind,
            pageIdx: locationInfo?.pageIdx || 1
        })
    }, [])

    /**
     * 문서 삭제 콜백
     */
    useEffect(() => {
        if (props.isDelete === true) {
            sessionStorage.removeItem(props.data?.step1?.docid);
            window.location.replace('/service/inbox');
        }
    }, [props.isDelete])


    useEffect(() => {

        if(props.data?.step1?.docid) {
            //임시저장 상태
            if (props.data?.step1.sts === "01") {
                history.replace('/service/apply/1?seq=' + props.match.params.seq);
            } else {
                setState(props.data);
            }
        }
    }, [props.data])


    const doDelete = () => {
        props.confirm({
            title: '확인',
            message: '증명서를 삭제하시겠습니까?',
            params: {
                type: 'confirm',
                callback: () => {
                    props.deleteDoc(props.data?.step1?.crtIssueSeq);
                }
            }
        })
    }

    const goList = () => {
        let paramStr = queryString.stringify(historyInfo);
        paramStr.length > 0 && ( paramStr = "?" + paramStr )
        history.push('/service/inbox' + paramStr)
    }

    return(
        <React.Fragment>
            <div className="ServiceDashboard">
                <ServiceDashboard />
            </div>
            <div className="detail-table">
                <div className="service-title">
                    구매확인서 발급 신청
                </div>

                {/************** 일반 정보 **************/}
                {state?.step1 &&
                <>
                    <div className="detail-table-box">
                        <div className="detail-title">정보</div>

                            <div className="row">
                                <ul className="flex-col">
                                    <li className="flex-sb w-full ">
                                        <div className="flex-row w-full item">
                                            <span className="w-50">전자문서번호</span>
                                            <span className="w-50 text-right">{state.step1.docid}</span>
                                        </div>
                                    </li>
                                    <li className="flex-sb w-full ">
                                        <div className="flex-row w-full item">
                                            <span className="w-50">수신처(발급기관)</span>
                                            <span className="w-50 text-right">{state.step1.issueNm}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                    </div>
                    <div className="detail-table-box">
                        <div className="detail-title">일반정보</div>
                        <div className="detail-table-scroll">
                            <ul className="flex-col infor-detail">
                                <li className="row w-100 item">
                                    <div className="inforT">신청인</div>
                                    <div className="flex-row w-full">
                                        <span className="tit">상호</span>
                                        <span>{state.step1.lctorgnm}</span>
                                    </div>
                                    <div>
                                        <span className="tit">성명</span>
                                        <span>{state.step1.lctceonm}</span>
                                    </div>
                                    <div>
                                        <span className="tit">사업자등록번호</span>
                                        <span>{state.step1.lctprtid}</span>
                                    </div>
                                    <div>
                                        <span className="tit">주소</span>
                                        <span>{state.step1.lctaddr1}</span>
                                        {state.step1.lctaddr2 && <span>{state.step1.lctaddr2}</span>}
                                        {state.step1.lctaddr3 && <span>{state.step1.lctaddr3}</span>}
                                    </div>
                                </li>
                                <li className="row w-100 item">
                                    <div className="inforT">공급자</div>
                                    <div>
                                        <span className="tit">상호</span>
                                        <span>{state.step1.splyCmpyNm}</span>
                                    </div>
                                    <div>
                                        <span className="tit">성명</span>
                                        <span>{state.step1.splynm}</span>
                                    </div>
                                    <div>
                                        <span className="tit">사업자등록번호</span>
                                        <span>{state.step1.splyprtnum}</span>
                                    </div>
                                    <div>
                                        <span className="tit">주소</span>
                                        <span>{state.step1.splyaddr1}</span>
                                        {state.step1.splyaddr2 && <span>{state.step1.splyaddr2}</span>}
                                        {state.step1.splyaddr3 && <span>{state.step1.splyaddr3}</span>}
                                    </div>
                                </li>
                                <li className="row w-100 item">
                                    <div>
                                        {state.step1.splycd &&
                                        <div>
                                            <span className="tit">수발신인식별자</span>
                                            <span>{state.step1.splycd}</span>
                                        </div>
                                        }

                                        {state.step1.splycd &&
                                        <div>
                                            <span className="tit">수발신인식별자</span>
                                            <span>{state.step1.splycd}</span>
                                        </div>
                                        }

                                        {state.step1.emlAddr &&
                                        <div>
                                            <span className="tit">이메일주소</span>
                                            <span>{state.step1.emlAddr}</span>
                                        </div>
                                        }
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </>
                }
                {/************** 구매물품 정보 **************/}
                {state?.step2 &&
                <div className="detail-table-box">
                    <div className="detail-title">구매물품</div>
                    <div className="header">
                        <ul>
                            <li className="col w-15">HS부호</li>
                            <li className="col w-15 ">품명</li>
                            <li className="col w-15">규격</li>
                            <li className="col w-15">수량</li>
                            <li className="col w-15">구매일</li>
                            <li className="col w-15">단가
                                <br/>{state.step2[0].totamtcur}
                            </li>
                            <li className="col w-15">금액
                                <br/>{state.step2[0].totamtcur}
                            </li>
                        </ul>
                    </div>
                    <div className="row">
                        {
                            state.step2?.length > 0 ?
                                state.step2?.map((goods, index) => {
                                    return <ul key={index}>
                                        <li className="col w-15" data-title={"HS부호"}><span>{goods.hsCd}</span></li>
                                        <li className="col w-15" data-title={"품명"}><span>{goods.itemnm}</span></li>
                                        <li className="col w-15" data-title={"규격"}><span>{goods.itemdeftxt}</span></li>
                                        <li className="col w-15" data-title={"수량"}><span>{goods.grcnt}</span></li>
                                        <li className="col w-15"
                                            data-title={"구매일"}><span>{moment(goods.crtYmd).format('YYYY-MM-DD')}</span></li>
                                        <li className="col w-15"
                                            data-title={"단가"}><span>{goods?.baseAmt && commons.addComma(goods.baseAmt)}</span></li>
                                        <li className="col w-15"
                                            data-title={"금액"}><span>{goods?.gramt && commons.addComma(goods.gramt)}</span></li>
                                    </ul>
                                })
                                : <div>검색된 자료가 없습니다.</div>
                        }
                    </div>
                </div>
                }
                {/************** 근거자료 정보 **************/}
                {state?.step3 &&
                <div className="detail-table-box">
                    <div className="detail-title">근거서류</div>
                    <div className="header">
                        <ul>
                            <li className="col w-15">근거서류명 및 번호</li>
                            <li className="col w-15">HS부호</li>
                            <li className="col w-15">품명</li>
                            <li className="col w-15">규격</li>
                            <li className="col w-15">금액</li>
                            <li className="col w-15">선적기일</li>
                        </ul>
                    </div>
                    <div className="row">
                        {
                            state.step3?.length > 0 ?
                                state.step3?.map((item, index) => {
                                    return <ul key={index}>
                                        <li className="col w-15" data-title={"근거서류명 및 번호"}>
                                            <span>
                                            {fileType.find((file) => {
                                                return file.value === item.fileCd
                                            })?.title}
                                            <span>[{item.fileNo}]</span>
                                            </span>
                                        </li>
                                        <li className="col w-15" data-title={"HS부호"}><span>{item.hsCd}</span></li>
                                        <li className="col w-15" data-title={"품명"}><span>{item.itemnm}</span></li>
                                        <li className="col w-15" data-title={"규격"}><span>{item.itemdeftxt}</span></li>
                                        <li className="col w-15"
                                            data-title={"금액"}><span>{item.totamtcur} {item?.amt && commons.addComma(item.amt)}</span></li>
                                        <li className="col w-15" data-title={"선적기일"}><span>{moment(item.stngYmd).format('Y-M-D')}</span></li>
                                    </ul>
                                })
                                : <div>검색된 자료가 없습니다.</div>
                        }
                    </div>
                </div>
                }
                {/************** 세금계산서 정보 **************/}
                {state?.step4 &&
                <div className="detail-table-box">
                    <div className="detail-title">세금계산서</div>
                    <div className="header">
                        <ul>
                            <li className="col w-15">세금계산서 번호</li>
                            <li className="col w-15">품명</li>
                            <li className="col w-15">규격</li>
                            <li className="col w-15">공금가액</li>
                            <li className="col w-15">세액</li>
                            <li className="col w-15">수량</li>
                            <li className="col w-15">선적기일</li>
                        </ul>
                    </div>
                    <div className="row">
                        {
                            state.step4?.length > 0 ?
                                state.step4?.map((item, index) => {
                                    return <ul key={index}>
                                        <li className="col w-15" data-title={"세금계산서번호"}><span>{item.taxNo}</span></li>
                                        <li className="col w-15" data-title={"품명"}><span>{item.itemnm}</span></li>
                                        <li className="col w-15" data-title={"규격"}><span>{item.itemdeftxt}</span></li>
                                        <li className="col w-15"
                                            data-title={"공급가액"}><span>{item?.splyAmt && commons.addComma(item.splyAmt)}</span></li>
                                        <li className="col w-15"
                                            data-title={"세액"}><span>{item?.taxAmt && commons.addComma(item.taxAmt)}</span></li>
                                        <li className="col w-15"
                                            data-title={"수량"}><span>{item?.itemqty && commons.addComma(item.itemqty)} {item.itemqtyunitcd}</span></li>
                                        <li className="col w-15" data-title={"작성일자"}><span>{moment(item.writedt).format('Y-M-D')}</span></li>
                                    </ul>
                                })
                                : <div>검색된 자료가 없습니다.</div>
                        }
                    </div>
                </div>
                }


                <div className="w-100 text-center">
                    <button className="btn btn-white" onClick={goList}>목록으로</button>
                    {state?.step1.sts === "04" &&
                    <button className="btn btn-blue" onClick={doDelete}>삭 제</button>
                    }
                </div>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        data: state.contracter.data,
        isDelete: state.contracter.isDelete
    }
}

const actionCreators = {
    load: contracterActions.load,
    deleteDoc : contracterActions.deleteTempDoc,
    confirm: alertActions.confirm,
}

export default connect(
    mapStateToProps,
    actionCreators
)(CertificateApplyDetail)
